import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { AccountingReportsPeriodSelector } from "./AccountingReportsPeriodSelector";
import { AccountingReportsSummary } from "./AccountingReportsSummary";

export function AccountingReportsTab() {
  const { authAxios } = useAuth();
  const [period, setPeriod] = useState("3months");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadSummary();
  }, [period, dateFrom, dateTo]);

  const loadSummary = async () => {
    try {
      setLoading(true);
      let url = `/financiero/accounting-reports/summary`;

      if (period === "custom") {
        if (!dateFrom || !dateTo) {
          setLoading(false);
          return;
        }
        url += `?date_from=${dateFrom}&date_to=${dateTo}`;
      } else {
        url += `?period=${period}`;
      }

      const res = await authAxios.get(url);
      setSummary(res.data);
    } catch (err) {
      toast.error("Error al cargar el resumen");
    } finally {
      setLoading(false);
    }
  };

  const handlePeriodChange = (newPeriod) => {
    setPeriod(newPeriod);
    setDateFrom("");
    setDateTo("");
  };

  const handleGenerateReport = async () => {
    if (period === "custom" && (!dateFrom || !dateTo)) {
      toast.error("Seleccione fecha inicial y final");
      return;
    }
    await loadSummary();
  };

  return (
    <div className="space-y-6">
      <AccountingReportsPeriodSelector
        period={period}
        dateFrom={dateFrom}
        dateTo={dateTo}
        loading={loading}
        onPeriodChange={handlePeriodChange}
        onDateFromChange={setDateFrom}
        onDateToChange={setDateTo}
        onGenerateReport={handleGenerateReport}
      />
      <AccountingReportsSummary
        summary={summary}
        period={period}
        dateFrom={dateFrom}
        dateTo={dateTo}
      />
    </div>
  );
}
